
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 498","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M505.1 260.7h-20.6v1.4c-1.4-49.5-45.4-88.1-96.3-81.2-42.7 5.5-72.9 44-72.9 86.7v89.5c0 53.7-39.9 100.5-92.2 104.6-55.1 4.1-101.8-34.4-108.7-85.3h33c4.1 0 6.9-2.8 6.9-6.9v-48.2h34.4c4.1 0 6.9-2.8 6.9-6.9V183.7h68.8v-41.3h61.9c4.1 0 6.9-2.8 6.9-6.9V48.8c0-4.1-2.8-6.9-5.5-6.9h-61.9V7.5c-1.4-4.1-4.1-6.9-6.9-6.9H6.9C2.8.6 0 3.4 0 7.5V313c0 4.1 2.8 6.9 6.9 6.9h34.4v48.2c0 4.1 2.8 6.9 6.9 6.9H84c8.3 70.2 71.6 123.9 145.9 115.6 67.4-6.9 118.4-67.4 118.4-136.3v-90.8c0-24.8 16.5-48.2 41.3-53.7 34.4-6.9 63.3 17.9 64.7 50.9h-20.6c-4.1 0-6.9 2.8-6.9 6.9v112.9c0 4.1 2.8 6.9 6.9 6.9h71.6c4.1 0 6.9-2.8 6.9-6.9V267.6c-.2-4.1-3-6.9-7.1-6.9zM264.3 72.2h38.5v38.5h-38.5zm-68.9-41.3H234V152h-38.5V30.9zM41.3 289.6h-11V30.9h134.9v258.8H41.3zm30.3 55.1v-24.8h52.3v24.8zm410.1 13.8h-24.8v-66.1h24.8z"}})])
          )
        }
      }
    